var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"timer"},[_vm._l((_vm.showOnFormat),function(timeValue,idx){return [_c('span',{key:idx,staticClass:"timer__value"},[_vm._v(" "+_vm._s(timeValue)+" ")]),(idx !== _vm.showOnFormat.length - 1)?_c('span',{key:idx + 'sep',staticClass:"timer__separator"},[_vm._v(" : ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }